import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { CircularProgress, Box } from '@mui/material';

const ProtectedRoute = ({ children, adminOnly = false, clientOnly = false }) => {
  const { currentUser, userProfile } = useAuth();

  if (!currentUser) {
    return <Navigate to="/auth" replace />;
  }

  // Vérifier que l'email est vérifié
  if (currentUser && !currentUser.emailVerified) {
    return <Navigate to="/auth" replace />;
  }

  if (!userProfile) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }


  // Admin access control
  if (adminOnly && userProfile.role !== 'admin') {
    // Redirect based on user role
    if (userProfile.role === 'client') {
      return <Navigate to="/client-dashboard" replace />;
    } else if (userProfile.role === 'salon') {
      return <Navigate to="/dashboard" replace />;
    }
    return <Navigate to="/my-dashboard" replace />;
  }

  // Client-only routes
  if (clientOnly && userProfile.role !== 'client') {
    if (userProfile.role === 'salon') {
      return <Navigate to="/dashboard" replace />;
    }
    return <Navigate to="/my-dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;